module.exports = __webpack_public_path__ + "static/fonts/Roboto-Light.69f8a06.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Light.woff2
// module id = 315
// module chunks = 1